import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";
import { error } from "console";

@Injectable()
export class IntegrateSelloutServices {
  headers: Headers;
  url = environment.qrcode_url_aps;

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  selloutHistory(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/v1/sale_out/settings`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  selloutDetail(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/v1/sale_out/settings/batch`, {
        headers: this.headers,
        params: query
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  updateSelloutCampaign(body?: any): Observable<any> {
    return this.http
      .put(`${this.url}/sale_out/settings`, body, {
        headers: this.headers,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  removeSelloutCampaign(query?: any): Observable<any> {
    return this.http
      .delete(`${this.url}/sale_out/settings`, {
        headers: this.headers,
        params: query
      }
      )
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  // TuanHA: get API campaigns of 1 sellout
  getSelloutCampaigns(query?: any): Observable<any> {
    return this.http
      .get(`${this.url}/v1/sale_out/settings/campaigns`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }
}


// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-sellout/services/inegrate-sellout.services.ts